import Modal from 'react-bootstrap/Modal';

function Modals(props) {
    const { showCloseButton = true, ...otherProps } = props;

    return (
        <Modal
            {...otherProps}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className={props.className}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton={showCloseButton}>
                <Modal.Title id="example-modal-sizes-title-sm" className='orange'>
                    {props.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>{props.children}</Modal.Body>
        </Modal>
    );
}

export default Modals;